import client, { throwCaughtError } from "../client";
import { Entrance } from "@/types";
import { UseSuspenseQueryResult } from "@tanstack/react-query";
import { useBuildingSuspenseQuery } from "@/components/RouterSetup";

export const useEntrance = (
  entranceId: string,
): UseSuspenseQueryResult<Entrance> => {
  return useBuildingSuspenseQuery({
    queryKey: ["entrance", entranceId],
    queryFn: async () => {
      try {
        const response = await client.get(
          `/getEntranceById?entranceId=${entranceId}`,
        );
        return response.data;
      } catch (error) {
        throwCaughtError(error);
      }
    },
  });
};

export const getQrCode = async (entranceId: string): Promise<string> => {
  return (await client.get(`/getEntranceQrCode?entranceId=${entranceId}`)).data
    .dataURI;
};

export const allEntrancesOptions = {
  queryKey: ["entrances"],
  queryFn: async (): Promise<Entrance[]> => {
    try {
      const response = await client.get("/getAllEntrances");
      return response.data;
    } catch (error) {
      throwCaughtError(error);
      return [];
    }
  },
};

export const useAllEntrances = (): UseSuspenseQueryResult<Entrance[]> => {
  return useBuildingSuspenseQuery(allEntrancesOptions);
};

export const createEntrance = async (data: Entrance) => {
  return await client.post("/createEntrance", data);
};

export const updateEntrance = async (
  entranceId: string,
  updateData: Partial<Entrance>,
) => {
  return await client.post("/updateEntrance", {
    entranceId,
    updateData,
  });
};

export const deleteEntrance = async (entranceId: string) => {
  return await client.delete("/deleteEntrance", {
    data: { entranceId },
  });
};
